module.exports = __webpack_public_path__ + "img/xiangchang.9067fa55.jpg";